import { render, staticRenderFns } from "./discountHistory.vue?vue&type=template&id=4b1af72c&"
import script from "./discountHistory.vue?vue&type=script&lang=js&"
export * from "./discountHistory.vue?vue&type=script&lang=js&"
import style0 from "./discountHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports